import PropTypes from 'prop-types';
import React from 'react';
import FunctionalTestTarget, {
  FUNCTIONAL_TEST_IDS,
} from 'components/FunctionalTestTarget';
import Icon from 'components/Icon';
import './AvatarImage.css';

const AvatarImage = ({avatarKey, shade, width, ...rest}) =>
  avatarKey ? (
    <FunctionalTestTarget id={FUNCTIONAL_TEST_IDS.GENERAL__AVATAR_IMAGE}>
      <img src={`/avatar/userImage/${width}?key=${avatarKey}`} {...rest} />
    </FunctionalTestTarget>
  ) : (
    <Icon
      icon={Icon.OPTIONS.AVATAR}
      className="AvatarImage__FallbackIcon"
      shade={shade}
      {...rest}
    />
  );

AvatarImage.propTypes = {
  avatarKey: PropTypes.string,
};

AvatarImage.defaultProps = {
  width: 100,
};

export default AvatarImage;
